import axios from 'axios'

export default {
  list(params) {
    return axios.get('/roles', { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  get(id) {
    return axios.get('/roles/' + id).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  save(data) {
    return axios.post('/roles', data).then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  delete(id) {
    return axios.post('/roles/' + id + '/delete').then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
}
